import type {
    ComposableOptionsBase,
    ProductAttrsGroupSpec,
    ProductAttrsMaps,
    ProductAttrsSkuOption
} from '~/types';
import { intersection as lo_intersection } from 'es-toolkit';

export interface UseProductSpecsOptions extends ComposableOptionsBase {}
export function useProductSpecs(options: Partial<UseProductSpecsOptions> = {}) {

    function processSpec(
        specGroup: ProductAttrsGroupSpec,
        valFilter?: string[]
    ): Nullable<[string, string[]]> {
        let output: Nullable<[string, string[]]> = null;
        const { name } = specGroup.attribute;
        const vals = valFilter ? specGroup.groupValues.reduce((acc: string[], specOpt: ProductAttrsSkuOption) => {
            if (valFilter.includes(specOpt.value.uid!)) {
                acc.push(specOpt.value.name);
            }

            return acc;
        }, []) : specGroup.groupValues.map((specOpt: ProductAttrsSkuOption) => specOpt.value.name);

        if (vals.length) {
            output = [name, vals];
        }

        return output;
    }

    function processSpecs(
        specGroups: ProductAttrsGroupSpec[],
        attrsMaps?: ProductAttrsMaps,
        attrValUidsFilter: Nilish<string[]> = []
    ): [string, string[]][] {
        return specGroups.reduce((acc: [string, string[]][], specGroup) => {
            const { isVisible, attribute } = specGroup;

            if (isVisible) {
                const { uid } = attribute;
                let spec: Nilish<[string, string[]]>;

                if (attrsMaps) {
                    const filter = lo_intersection<string>(
                        attrsMaps.attrs[uid] || [],
                        attrValUidsFilter || []
                    );
                    spec = processSpec(specGroup, filter);
                } else {
                    spec = processSpec(specGroup);
                }
                
                if (spec) {
                    acc.push(spec);
                }
            }

            return acc;
        }, []);
    }
    
    return {
        processSpecs
    };
}
